/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Location from "../../../commanPage/location/Location";
import { useMediaQuery } from "react-responsive";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateGstDetails } from "../../../../redux/action/gtsVerification";
import { ClipLoader } from "react-spinners";
import { notifyError } from "../../../../helpers/helpers";

function VerifyGstDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isLaptop = useMediaQuery({ query: "(max-width: 1480px)" });
  const isTablet = useMediaQuery({ query: "(max-width: 999px)" });
  const { gstLoading } = useSelector((state) => state?.gstVerification);
  const [panCardNumber, setPanCardNumber] = useState("");
  const [gstCollection, setGstCollection] = useState({
    organizationName: "",
    location: {
      address: "",
      state: "",
      city: "",
      country: "",
      longitude: "",
      latitude: "",
    },
  });
  const [editValue, setEditValue] = useState(false);
  const [values, setValues] = useState({
    location: {
      address: "",
      state: "",
      city: "",
      country: "",
      longitude: "",
      latitude: "",
    },
  });

  const validateInputs = (panCardNumber, gstCollection) => {
    if (!gstCollection.organizationName.trim()) {
      notifyError("Organization name is required");
      return true;
    }
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    if (!panRegex.test(panCardNumber)) {
      if (panCardNumber === "") {
        notifyError("Pan card number is required");
        return true;
      }
      notifyError("Pan card number is invalid ");
      return true;
    }

    if (!gstCollection.location.address.trim()) {
      notifyError("Address is required");
      return true;
    }

    if (!gstCollection.location.state.trim()) {
      notifyError("State is required");
      return true;
    }

    if (!gstCollection.location.city.trim()) {
      notifyError("City is required");
      return true;
    }

    if (!gstCollection.location.country.trim()) {
      notifyError("Country is required");
      return true;
    }
    if (
      isNaN(gstCollection.location.longitude) ||
      isNaN(gstCollection.location.latitude)
    ) {
      notifyError("Longitude and latitude must be a number");
      return true;
    }

    return false;
  };

  useEffect(() => {
    setGstCollection((pre) => ({
      ...pre,
      location: {
        address: values?.location?.address,
        city: values?.location?.city || values?.location?.address,
        state: values?.location?.state,
        country: values?.location?.address,
        longitude: values?.location?.longitude,
        latitude: values?.location?.latitude,
      },
    }));
  }, [values]);

  const handleSumbit = () => {
    if (validateInputs(panCardNumber, gstCollection)) return;
    dispatch(updateGstDetails(gstCollection, panCardNumber, navigate));
  };

  return (
    <div className="auth-from slide-in" style={{ width:isLaptop ?"700px": "" }}>
      <div className={`flex  full-width`}>
        <span
          className="material-symbols-outlined pointer"
          onClick={() => navigate(-1)}
        >
          arrow_back
        </span>
      </div>

      <div style={{ width:isTablet?"100%": "420px", margin: "auto" }}>
        <h3 className="flex justify-center mb-2">Account Information</h3>
        <p className="font-18px">Enter your gst number</p>
        <div className="input-field-style margin-0px">
          <span className="material-symbols-outlined">apartment</span>
          <input
            className="browser-default"
            placeholder="Enter your gst number"
            type="text"
            name="gstNumber"
            disabled={true}
            value={id}
          />
        </div>

        <div className="cover p-1 mt-1 flex column gap-1 purple lighten-5 pin-top">
          <span>
            <p>
              Organization Name <span className="red-text">*</span>
            </p>
            {editValue ? (
              <p className="font-16px">{gstCollection?.organizationName}</p>
            ) : (
              <input
                type="text"
                value={gstCollection?.organizationName}
                name="organizationName"
                className={`input-tag-style input-width`}
                onChange={(e) =>
                  setGstCollection({
                    ...gstCollection,
                    organizationName: e.target.value,
                  })
                }
                required
              />
            )}
          </span>
          <span>
            <p>
              Pan Card Number <span className="red-text">*</span>
            </p>
            {editValue ? (
              <p className="font-16px">{panCardNumber}</p>
            ) : (
              <input
                type="text"
                value={panCardNumber}
                name="panCardNumber"
                className={`input-tag-style input-width`}
                onChange={(e) => setPanCardNumber(e.target.value.toUpperCase())}
                required
              />
            )}
          </span>
          <span>
            {editValue ? (
              <>
                <p>
                  Address <span className="red-text">*</span>
                </p>
                <p style={{ whiteSpace: "pre-wrap" }}>
                  {gstCollection.address}
                </p>
              </>
            ) : (
              <div style={{ marginRight: "1.3rem" }}>
                <Location values={values} setValues={setValues} />
              </div>
            )}
          </span>
          <span
            className="material-symbols-outlined select-label pointer"
            style={{ right: "6px", top: "6px" }}
            onClick={() => setEditValue((pre) => !pre)}
          >
            edit
          </span>
        </div>

        <div className="flex justify-center mt-3 gap-2">
          <button
            className={`button-style bold cercle-purple white-text pointer`}
            style={{ padding: "10px 35px" }}
            type="submit"
            onClick={() => handleSumbit()}
          >
            {gstLoading ? <ClipLoader color="#fff" size={20} /> : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default VerifyGstDetail;
